import React, { useState } from "react";

const OfflineScreen = ({ onRetry }) => {
  const [isChecking, setIsChecking] = useState(false);
  const [retryFailed, setRetryFailed] = useState(false);

  const handleRetry = async () => {
    if (isChecking) return;
    setIsChecking(true);
    setRetryFailed(false);

    // Simulate checking connection & run fetch check
    // const serverUrl = "http://localhost:8830";
    const serverUrl = process.env.REACT_APP_PUBLIC_NODE_URL || "http://localhost:8830";

    try {
      // 1. First check navigator online status
      if (!navigator.onLine) {
        throw new Error("Navigator offline");
      }

      // 2. Perform a real ping to the backend server with cache-busting to bypass cache
      await fetch(`${serverUrl}/user/get-all-mines?cb=${Date.now()}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        mode: "no-cors", // safe cross-origin ping check
      });

      // If we got here without throwing, network is restored
      setTimeout(() => {
        setIsChecking(false);
        if (onRetry) {
          onRetry();
        } else {
          window.location.reload();
        }
      }, 1000);
    } catch (err) {
      setTimeout(() => {
        setIsChecking(false);
        setRetryFailed(true);
      }, 1200);
    }
  };

  return (
    <div className="offlineWrapper">
      <div className="offlineCard">
        {/* Glowing Radar Waves */}
        <div className="offlineRadarGroup">
          <div className="offlineRadarRing ring-1"></div>
          <div className="offlineRadarRing ring-2"></div>
          <div className="offlineIconWrapper">
            <svg viewBox="0 0 24 24" className="offlineIcon">
              <path d="M1 8.5C3.5 6 7 4.5 11 4.5C15 4.5 18.5 6 21 8.5" />
              <path d="M4 11.5C6 9.5 8.5 8.5 11 8.5C13.5 8.5 16 9.5 18 11.5" />
              <path d="M7 14.5C8 13.5 9.5 12.5 11 12.5C12.5 12.5 14 13.5 15 14.5" />
              <circle cx="11" cy="18.5" r="1.5" />
              <line x1="1" y1="23" x2="23" y2="1" className="offlineSlash" />
            </svg>
          </div>
        </div>

        <h1 className="offlineTitle">You are offline</h1>
        <p className="offlineSubtitle">Please check your internet connection or network status and try refreshing.</p>

        {retryFailed && <div className="offlineErrorBadge">Connection failed. Still offline.</div>}

        <button className={`offlineRetryBtn ${isChecking ? "loading" : ""}`} onClick={handleRetry} disabled={isChecking}>
          {isChecking ? (
            <>
              <svg className="offlineSpinner" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="10" fill="none" strokeWidth="3" />
              </svg>
              Checking Connection...
            </>
          ) : (
            "Retry Connection"
          )}
        </button>
      </div>
    </div>
  );
};

export default OfflineScreen;
